<template>
  <div class="path-container" :title="filePath">
    <span class="directories">{{ fileDirectoryPath }}</span>
    <span class="file-name">{{ fileName }}</span>
  </div>
</template>

<script setup>


import { computed } from "vue";

const props = defineProps(['filePath'])

const fileName = computed(() => props.filePath.split('/').pop() )
const fileDirectoryPath = computed(() => {
  let pathDirectories = props.filePath.split('/')
  pathDirectories.pop()
  return pathDirectories.length > 0 ? pathDirectories.join('/') + '/' : null
})
</script>

<style scoped lang="scss">
.path-container {
  display: flex;
  justify-content: flex-start;
  text-wrap: nowrap;

  overflow: hidden;
  text-overflow: ellipsis;

  .directories {
    flex: 0 999999 auto;
    overflow: hidden;
    text-overflow: '.../';
  }

  .file-name {
    flex: 0 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
